<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption"
                       :data="tableData"
                       :table-loading="tableLoading"
                       :page="page"
                       ref="crud"
                       @search-change="searchChange"
                       @refresh-change="refreshChange"
                       @row-save="handleSave"
                       @row-update="handleUpdate"
                       @selection-change="handleSelectionChange"
                       @size-change="pageSizeChange"
                       @current-change="pageChange">
                <template slot-scope="scope" slot="menu">
                    <el-button type="primary"
                               icon="el-icon-d-arrow-right"
                               size="small"
                               plain
                               v-if="scope.row.status=='UNSENT'"
                               @click.stop="send(scope.row.id)"
                    >发送
                    </el-button>
                    <el-button type="success"
                               icon="el-icon-view"
                               size="small"
                               plain
                               @click.stop="show(scope.$index, scope.row)"
                    >查看
                    </el-button>
                    <el-button type="primary"
                               icon="el-icon-edit"
                               size="small"
                               plain
                               v-if="scope.row.status=='RETURNED'||scope.row.status=='UNSENT'"
                               @click.stop="show2(scope.$index, scope.row)"
                    >编辑
                    </el-button>
                </template>
                <template slot-scope="scope" slot="status">
                    <el-tag v-for="obj of checkStatus" :key="obj.value" v-if="obj.value == scope.row.status">
                        {{obj.label}}
                    </el-tag>
                </template>
            </avue-crud>
            <!--查看弹出框-->
            <el-dialog title="客户对账单详情" :visible.sync="details">
                <el-form>
                    <el-form-item label="客户电话:">
                        <el-input style="width: 500px" :disabled="true" v-model="detailsData.mobile"></el-input>
                    </el-form-item>
                    <el-form-item label="客户姓名:">
                        <el-input style="width: 500px" :disabled="true" v-model="detailsData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="客户店铺:">
                        <el-input style="width: 500px" :disabled="true" v-model="detailsData.shopName"></el-input>
                    </el-form-item>
                    <el-form-item label="客户区域:">
                        <el-input style="width: 500px" :disabled="true" v-model="detailsData.area"></el-input>
                    </el-form-item>
                    <el-form-item label="请选择客户负责人:" style="width: 300px;">
                        <el-input style="width: 300px;margin-right: 30px" :disabled="true"
                                  v-model="detailsData.departmentName"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 300px;float: right;margin-top: -62px;margin-right: 30px">
                        <el-input style="width: 300px" :disabled="true" v-model="detailsData.stuffName"></el-input>
                    </el-form-item>
                    <el-form-item label="请选择对账时间范围:" style="width: 300px">
                        <el-input style="width: 300px" v-model="detailsData.startTime" :disabled="true"></el-input>
                        <!--<el-date-picker style="width: 300px"-->
                        <!--:disabled="true"-->
                        <!--value-format="yyyy-MM-dd"-->
                        <!--:value="detailsData.startTime"-->
                        <!--v-model="detailsData.startTime"-->
                        <!--type="date"-->
                        <!--placeholder="选择日期">-->
                        <!--</el-date-picker>-->
                    </el-form-item>
                    <el-form-item style="width: 300px;float: right;margin-top: -62px;margin-right: 30px">
                        <el-input style="width: 300px" v-model="detailsData.endTime" :disabled="true"></el-input>
                        <!--<el-date-picker style="width: 300px"-->
                        <!--:disabled="true"-->
                        <!--:value="detailsData.endTime"-->
                        <!--value-format="yyyy-MM-dd"-->
                        <!--v-model="detailsData.endTime"-->
                        <!--type="date"-->
                        <!--placeholder="选择日期">-->
                        <!--</el-date-picker>-->
                    </el-form-item>
                    <!--<el-form-item label="请输入客户确认天数:">-->
                    <!--<br>-->
                    <!--<el-input style="width: 600px" :disabled="true" v-model="detailsData.days"></el-input>-->
                    <!--</el-form-item>-->
                    <el-form-item label="客户本期对账进货总金额:">
                        <br>
                        <el-input style="width: 600px" :disabled="true"
                                  v-model="detailsData.currentTotalBalance"></el-input>
                    </el-form-item>
                    <el-form-item label="客户账户总余额:">
                        <br>
                        <el-input style="width: 600px" :disabled="true" v-model="detailsData.totalBalance"></el-input>
                    </el-form-item>
                    <el-form-item label="对账单状态">
                        <br>
                        <el-input style="width: 600px" v-model="detailsData.status" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="客户确认时间:" style="width: 300px">
                        <el-input style="width: 600px" v-model="detailsData.confirmTime" :disabled="true"></el-input>
                        <!--<el-date-picker style="width: 300px"-->
                        <!--:disabled="true"-->
                        <!--value-format="yyyy-MM-dd"-->
                        <!--:value="detailsData.confirmTime"-->
                        <!--v-model="detailsData.confirmTime"-->
                        <!--type="date"-->
                        <!--placeholder="选择日期">-->
                        <!--</el-date-picker>-->
                    </el-form-item>
                    <el-form-item label="请输入客户进货明细:">
                        <el-table
                                :data="detailsDetail"
                                border>
                            <el-table-column
                                    align="center"
                                    label="单据编码">
                                <template slot-scope="scope">
                                    <el-input type="input" name="coding" :disabled="true"
                                              v-model="detailsDetail[scope.$index].documentsCoding"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="进货日期">
                                <template slot-scope="scope">
                                    <el-date-picker
                                            :disabled="true"
                                            value-format="yyyy-MM-dd"
                                            type="date"
                                            v-model="detailsDetail[scope.$index].stockTime"
                                            placeholder="选择日期">
                                    </el-date-picker>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="业务金额">
                                <template slot-scope="scope">
                                    <el-input type="input" name="money" :disabled="true"
                                              v-model="detailsDetail[scope.$index].stockMoney"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="单据凭证">
                                <template slot-scope="scope">
                                    <img style="width: 100px;height: 100px;margin-top: 10px" :src="item"
                                         v-for="(item,index) in detailsImgList[scope.$index]">
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="success" @click="getPdf()" style="display: none">导出PDF</el-button>
                </div>
            </el-dialog><!--查看弹出框结束-->
            <!--编辑弹出框-->
            <el-dialog title="编辑客户对账单" :visible.sync="edit">
                <el-form>
                    <el-form-item label="客户电话:">
                        <el-input style="width: 500px" v-model="editData.mobile"></el-input>
                    </el-form-item>
                    <el-form-item label="客户姓名:">
                        <el-input style="width: 500px" :disabled="true" v-model="editData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="客户店铺:">
                        <el-input style="width: 500px" :disabled="true" v-model="editData.shopName"></el-input>
                    </el-form-item>
                    <el-form-item label="客户区域:">
                        <el-input style="width: 500px" :disabled="true" v-model="editData.area"></el-input>
                    </el-form-item>
                    <el-form-item label="请选择客户负责人:" style="width: 300px;">
                        <el-select placeholder="请选择部门" v-model="editData.departmentName" :disabled="true">
                            <el-option style="width: 300px;"
                                       :value="editData.departmentName"

                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="width: 300px;float: right;margin-top: -62px;margin-right: 30px">
                        <el-select placeholder="请选择员工" v-model="editData.stuffName" :disabled="true">
                            <el-option style="width: 300px;"
                                       :value="editData.stuffName"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="请选择对账时间范围:" style="width: 300px">
                        <el-date-picker style="width: 300px"
                                        value-format="yyyy-MM-dd"
                                        v-model="editData.startTime"
                                        type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="width: 300px;float: right;margin-top: -62px;margin-right: 30px">
                        <el-date-picker style="width: 300px"
                                        value-format="yyyy-MM-dd"
                                        v-model="editData.endTime"
                                        type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <!--<el-form-item label="请输入客户确认天数:">-->
                    <!--<br>-->
                    <!--<el-input style="width: 600px" v-model="editData.days" :disabled="true"></el-input>-->
                    <!--</el-form-item>-->
                    <el-form-item label="客户本期对账进货总金额:">
                        <br>
                        <el-input style="width: 600px" :disabled="true" v-model="editMoney"></el-input>
                    </el-form-item>
                    <el-form-item label="客户账户总余额:">
                        <br>
                        <el-input style="width: 600px" :disabled="true" v-model="editData.totalBalance"></el-input>
                    </el-form-item>
                    <el-form-item label="请输入客户进货明细:">
                        <el-table
                                :data="editDetail"
                                border>
                            <el-table-column
                                    align="center"
                                    label="单据编码">
                                <template slot-scope="scope">
                                    <el-input type="input" name="coding"
                                              v-model=" editDetail[scope.$index].documentsCoding"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="进货日期">
                                <template slot-scope="scope">
                                    <el-date-picker
                                            value-format="yyyy-MM-dd"
                                            type="date"
                                            v-model="editDetail[scope.$index].stockTime"
                                            placeholder="选择日期">
                                    </el-date-picker>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="业务金额">
                                <template slot-scope="scope">
                                    <el-input type="input" name="money"
                                              v-model="editDetail[scope.$index].stockMoney"
                                              @change="editMoneyChange"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="单据凭证">
                                <template slot-scope="scope">
                                    <div @click="editIndex(scope.$index)">
                                        <el-upload :multiple="true" action="#"
                                                   accept="image/jpeg,image/gif,image/png,image/bmp"
                                                   :file-list="editUploadImg" :http-request="fnUploadBusinessRequest2"
                                                   :show-file-list="false">
                                            <div v-if="'' != editDetail[scope.$index].imgArray"
                                                 class="el-upload el-upload--picture-img">
                                                <!--<img v-for="src of editDetail[scope.$index].imgArray" :src="src" style="width: 200px;"/>-->
                                                <img v-for="src in editDetail[scope.$index].imgArray" :src="src"
                                                     :key="src" style="width: 200px;">

                                            </div>
                                            <div v-else class="el-upload el-upload--car-two">
                                                <i
                                                        class="el-icon-plus"></i>
                                            </div>
                                        </el-upload>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="操作">
                                <template slot-scope="scope">
                                    <el-button plain
                                               icon="el-icon-check"
                                               size="mini"
                                               type="warning"
                                               @click="editDeleteRows(scope.$index, scope.row)">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div style="margin-top: 20px">
                            <el-button @click="editAddRows()" type="success">增加一行</el-button>
                        </div>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">

                        <el-button type="primary" v-if="nowStatus=='UNSENT'" @click="updateDraftCheck">修改</el-button>
                        <el-button type="primary" v-if="nowStatus=='UNSENT'" @click="sendDraftCheck">发送对账单</el-button>
                        <el-button type="primary" v-if="nowStatus=='RETURNED'" @click="keepCheck">修改</el-button>
                        <el-button type="primary" v-if="nowStatus=='RETURNED'" @click="editSure">发送对账单</el-button>
                        <el-button type="success" style="display: none">导入Excel</el-button>


                </div>
            </el-dialog><!--编辑弹出框结束-->
        </basic-container>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {checkDetailOption} from "@/const/salesCloud/checkDetailOption";
    import {details, calculatedBalance, send, updateDraftCheck,keepCheck} from "@/api/salesCloud/checkDetail"
    import {getAliyunPublicToken} from "@/api/oss/aliyun";
    import oss from 'ali-oss';
    import md5 from 'js-md5';
    import {
        findBillList, findMobileShop, findUserBalance, findDepartment, findStaff, addBill, lookBillDetails,
        billEdit, findShop
    } from "@/api/salesCloud/bill";
    import {findByLabel, formatterTime} from "@/util/util"
    import {DIC} from "@/const/dic"

    export default {
        name: "checkDetail",
        data() {
            return {
                tableOption: checkDetailOption, //表格设置属性
                tableData: [], //表格的数据
                tablePage: 1,
                tableLoading: false,
                tabelObj: {},
                page: {
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 //每页显示多少条
                },
                grade: {
                    box: false,
                    check: []
                },
                id: this.$route.query.shopId,
                details: false,
                detailsData: {},
                checkStatus: DIC.CHECK_STATUS,
                details: false,
                detailsData: [],            //详情的数据存放
                detailsDetail: [],           //详情新增行的数组
                detailsUploadImg: [],        //详情上传图片名称的数组
                detailsImgList: [],         //详情显示图片的数组
                businessLicense: [], //存放服务器图片数组
                businessLicense2: [], //存放服务器图片数组2
                addIndex: '',      //上传图片的下标
                editData: [],           //编辑的数据存放
                edit: false,             //是否显示编辑弹出框
                editDetail: [],           //编辑新增行的数组
                editUploadImg: [],        //编辑上传图片名称的数组
                editImgList: [],         //编辑显示图片的数组
                balance: 0,
                editMoney: 0,
                nowStatus:""
            };
        },
        created() {
            console.log(this.id)
            calculatedBalance(this.id).then((res) => {
                this.balance = res.data
                this.handleList();
                //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
            })

        },
        watch: {},
        mounted() {
        },
        computed: {
            ...mapGetters(["permission"])
        },
        props: [],
        methods: {
            pageSizeChange(pageSize) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage,
                    params.size = pageSize
                details(this.id, params).then((res) => {
                    let data = JSON.parse(res.data);
                    // for(let i=0;i<data.rows.length;i++){
                    //     data.rows[i].totalBalance=this.balance
                    // }
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: pageSize
                    };
                    this.tableLoading = false;
                })
            },
            pageChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page
                params.size = this.page.pageSize
                details(this.id, params).then((res) => {
                    let data = JSON.parse(res.data);
                    // for(let i=0;i<data.rows.length;i++){
                    //     data.rows[i].totalBalance=this.balance
                    // }
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            searchChange(params) {
                this.tableLoading = true;
                // let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage
                params.size = this.page.pageSize
                details(this.id, params).then((res) => {
                    let data = JSON.parse(res.data);
                    // for(let i=0;i<data.rows.length;i++){
                    //     data.rows[i].totalBalance=this.balance
                    // }
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                })
            },
            refreshChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page.currentPage
                params.size = page.pageSize
                details(this.id, params).then((res) => {
                    let data = JSON.parse(res.data);
                    // for(let i=0;i<data.rows.length;i++){
                    //     data.rows[i].totalBalance=this.balance
                    // }
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page.currentPage,
                        pageSize: page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd() {
                this.$refs.crud.rowAdd();
            },
            handleEdit(row, index) {
                this.$refs.crud.rowEdit(row, index);
            },
            /**
             * @title 获取数据
             * @detail 赋值为tableData表格即可
             *
             **/
            handleList() {
                console.log(this.balance)
                this.tableLoading = true;
                let parmas = {
                    page: this.page.currentPage,
                    size: this.page.pageSize
                }
                details(this.id, parmas).then((res) => {
                    let data = JSON.parse(res.data);

                    // for(let i=0;i<data.rows.length;i++){
                    //     data.rows[i].totalBalance=this.balance
                    // }

                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 数据添加
             * @param row 为当前的数据
             * @param done 为表单关闭函数
             *
             **/
            handleSave(row, done) {
            },
            /**
             * @title 当前选中的数据
             * @param val 选中的值
             *
             **/
            handleSelectionChange() {
            },
            /**
             * @title 数据删除
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             *
             **/
            handleDel(dicName, label) {
            },
            /**
             * @title 数据更新
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             * @param done 为表单关闭函数
             *
             **/
            handleUpdate(row, index, done) {

            }, handleDetail(row, index) {
                this.$refs.crud.rowView(row, index)
            },
            detail(row) {
                this.details = true
                this.detailsData.startTime = row.startTime
                this.detailsData.endTime = row.endTime
                this.detailsData.returnReason = row.returnReason
                this.detailsData.currentTotalBalance = row.currentTotalBalance
                this.detailsData.totalBalance = row.totalBalance
                this.detailsData.status = row.status
                for (let i = 0; i < this.checkStatus.length; i++) {
                    if (this.checkStatus[i].value == row.status) {
                        this.detailsData.status = this.checkStatus[i].label
                    }
                }
            },
            formmaterImage(row) {
                let str = new Array();
                console.log("row：" + JSON.stringify(row))
                if (row != null) {
                    let picArray = row.split(",")
                    for (let i = 0; i < picArray.length; i++) {
                        // console.log("url："+ row[i].url)
                        str.push(picArray[i])
                    }
                }
                return str
            },
            show(i, data) {  //查看
                this.details = true;
                let id = data.id;
                //console.log(id);
                lookBillDetails(id).then((res) => {
                    let data = JSON.parse(res.data);

                    // data.area=data.province+data.city+data.area;
                    function getLocalTime(nS) {
                        return new Date(parseInt(nS)).toLocaleString().replace(/:\d{1,2}$/, ' ');
                    }

                    data.startTime = getLocalTime(data.startTime);
                    data.endTime = getLocalTime(data.endTime);
                    this.detailsData = data;
                    this.detailsDetail = data.stockDetailResponse;
                    this.detailsData.totalBalance = this.balance
                    if (data.confirmTime != null) {
                        this.detailsData.confirmTime = getLocalTime(data.confirmTime)
                    }

                    this.detailsData.area = this.detailsData.province + this.detailsData.city + this.detailsData.area;
                    for (let i = 0; i < this.detailsDetail.length; i++) {
                        this.detailsDetail[i].stockTime = getLocalTime(this.detailsDetail[i].stockTime);
                    }
                    for (let i = 0; i < this.checkStatus.length; i++) {
                        if (this.checkStatus[i].value == this.detailsData.status) {
                            this.detailsData.status = this.checkStatus[i].label
                        }
                    }
                    let imgArray = [];
                    //console.log(this.detailsDetail);

                    for (let i = 0; i < this.detailsDetail.length; i++) {
                        if (this.detailsDetail[i].billName == null) {
                            imgArray.push([])
                        } else {
                            let imgArray1 = [];
                            let billNames = this.detailsDetail[i].billName.split(',')
                            for (let j = 0; j < billNames.length; j++) {
                                if (billNames[j] != null && billNames[j] != '') {
                                    imgArray1.push(billNames[j])
                                }
                            }
                            imgArray.push(imgArray1)
                            //imgArray.push([])
                        }
                    }

                    this.detailsImgList = imgArray;
                    console.log(this.detailsData)
                });

            }, show2(i, data) {  //编辑
                //console.log(i,data);
                this.edit = true;
                let id = data.id;
                lookBillDetails(id).then((res) => {
                    let data = JSON.parse(res.data);

                    console.log(data);
                    this.editID = data.id;

                    function getLocalTime(nS) {
                        let date = new Date(nS);
                        let Y = date.getFullYear() + '-';
                        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                        let D = date.getDate() + ' ';
                        let h = date.getHours() + ':';
                        let m = date.getMinutes() + ':';
                        let s = date.getSeconds();
                        return Y + M + D + h + m + s;
                    }

                    data.startTime = getLocalTime(data.startTime);
                    data.endTime = getLocalTime(data.endTime);
                    this.nowStatus=data.status
                    this.editData = data;
                    this.detailsData.totalBalance = this.balance
                    this.editData.area = this.editData.province + this.editData.city + this.editData.area;
                    let array = this.editData.stockDetailResponse;
                    this.editDetail = [];
                    for (let i = 0; i < array.length; i++) {
                        this.editDetail.push(array[i])
                    }
                    for (let i = 0; i < this.editDetail.length; i++) {
                        this.editDetail[i].stockTime = getLocalTime(this.editDetail[i].stockTime);
                    }

                    for (let i = 0; i < array.length; i++) {
                        if (array[i].billName == null) {
                            this.editDetail[i].imgArray = [];
                        } else {
                            this.editDetail[i].imgArray = [];
                            this.editDetail[i].imgArray = array[i].billName.split(',');
                        }
                    }

                    this.editMoney = 0;
                    for (let i = 0; i < this.editDetail.length; i++) {
                        this.editMoney += parseInt(this.editDetail[i].stockMoney);
                    }

                });
            },
//编辑弹出框确认
            editSure() {
                this.edit = false;

                // let date=new Date();
                //
                // let startTime=date.getTime(this.editData.startTime);
                // let endTime=date.getTime(this.editData.endTime);
                let date1 = new Date(this.editData.startTime);
                let startTime = date1.getTime();
                let date2 = new Date(this.editData.endTime);
                let endTime = date2.getTime();

                let joinsSalesCloudStockDetails = [];
                let aaa = this.editDetail;

                for (let j = 0; j < aaa.length; j++) {
                    let obj = {};
                    obj.documentsCoding = aaa[j].documentsCoding;
                    console.log("stockTime：" + JSON.stringify(aaa[j].stockTime))
                    obj.stockTime = new Date(aaa[j].stockTime).getTime();
                    obj.stockMoney = aaa[j].stockMoney;
                    let b = '';
                    for (let k = 0; k < aaa[j].imgArray.length; k++) {
                        b += aaa[j].imgArray[k] + ","
                    }
                    b = b.substring(0, b.length - 1);
                    obj.billName = b;
                    console.log("obj：" + JSON.stringify(obj))
                    joinsSalesCloudStockDetails.push(obj)
                }


                let data = {
                    id: this.editID,
                    mobile: this.editData.mobile,
                    startTime: startTime,
                    endTime: endTime,
                    joinsSalesCloudStockDetails: joinsSalesCloudStockDetails,
                };
                console.log("data：" + JSON.stringify(data))
                billEdit(data).then((res) => {
                    console.log(res);
                    if (res.code == '200' || res.code == 200) {
                        calculatedBalance(this.id).then((res) => {
                            this.balance = res.data
                            //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                        })
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name: this.input,
                            mobile: this.input,
                            shopName: this.input,
                            province: this.city,
                            city: this.erae,
                            area: this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);

                            this.total = data.total;
                            for (let i = 0; i < data.rows.length; i++) {
                                data.rows[i].area = data.rows[i].province + data.rows[i].city + data.rows[i].area;
                            }
                            this.tableData = data.rows;
                            //console.log(this.tableData);
                        });
                    } else {
                        this.$message({
                            message: '修改失败!请正确修改信息！',
                            type: 'error'
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name: this.input,
                            mobile: this.input,
                            shopName: this.input,
                            province: this.city,
                            city: this.erae,
                            area: this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);

                            this.total = data.total;
                            for (let i = 0; i < data.rows.length; i++) {
                                data.rows[i].area = data.rows[i].province + data.rows[i].city + data.rows[i].area;
                            }
                            this.tableData = data.rows;
                            //console.log(this.tableData);
                        });
                    }
                });
                done();

            },
            editAddRows() {  //编辑弹出框新增一行
                let list = {
                    billName: "",
                    documentsCoding: "",
                    id: "",
                    imgArray: [],
                    stockTime: '',
                    stockMoney: '',
                };
                this.editDetail.push(list);
            },
            //计算编辑的金额
            editMoneyChange() {
                this.editMoney = 0;
                for (let i = 0; i < this.editDetail.length; i++) {
                    this.editMoney += parseInt(this.editDetail[i].stockMoney);
                }
                this.editData.totalBalance = this.editData.totalBalance - this.editMoney
            },
            async fnUploadBusinessRequest2(option) {
                this.tableLoading = true;
                getAliyunPublicToken().then((res) => {
                    let data = JSON.parse(res.data);
                    // console.log(data);
                    let client = new oss({
                        region: data.point,
                        endPoint: data.point,
                        accessKeyId: data.accessKeyId,
                        accessKeySecret: data.accessKeySecret,
                        Expiration: data.expiration,
                        bucket: data.bucketName,
                        stsToken: data.securityToken
                    });
                    const storeAs = md5(option.file.name);
                    client.multipartUpload(storeAs, option.file, {}).then(results => {
                        let res = results.res.requestUrls;
                        let files = new Array();
                        for (let url in res) {
                            let file = new Object();
                            file.label = storeAs;
                            file.value = url;
                            files.push(file)
                        }
                        this.fileList = files;
                        let array = results.res.requestUrls[0].split("?");

                        var list = {
                            coding: "",
                            date: '',
                            money: '',
                            voucher: '',
                            imgArray: [],
                        };
                        this.editDetail.push(list);

                        this.editDetail[this.addIndex].imgArray.push(array[0]);
                        this.editDetail.splice(this.editDetail.length - 1, 1);

                        this.tableLoading = false;
                    }).catch((err) => {
                        console.log(err);
                    });
                })
            },
            editIndex(i) {

                this.addIndex = i;
                console.log(this.addIndex);
            },
            send(id) {
                this.$confirm(`是否确认发送?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        send(id).then(response => {
                            if (response.code == '200') {
                                this.$message({
                                    showClose: true,
                                    message: "发送成功",
                                    type: "success"
                                });
                                this.handleList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.message,
                                    type: "error"
                                })
                            }

                        }).catch(error => {
                            this.loading = false
                            this.$message({
                                showClose: true,
                                message: error,
                                type: "error"
                            })
                        })
                    })
                    .catch(() => {
                    });
            },
            updateDraftCheck() {
                this.edit = false;

                // let date=new Date();
                //
                // let startTime=date.getTime(this.editData.startTime);
                // let endTime=date.getTime(this.editData.endTime);
                let date1 = new Date(this.editData.startTime);
                let startTime = date1.getTime();
                let date2 = new Date(this.editData.endTime);
                let endTime = date2.getTime();

                let joinsSalesCloudStockDetails = [];
                let aaa = this.editDetail;

                for (let j = 0; j < aaa.length; j++) {
                    let obj = {};
                    if (typeof aaa[j].id != "undefined" && aaa[j].id != "") {
                        obj.id = aaa[j].id
                    }
                    obj.documentsCoding = aaa[j].documentsCoding;
                    console.log("stockTime：" + JSON.stringify(aaa[j].stockTime))
                    obj.stockTime = new Date(aaa[j].stockTime).getTime();
                    obj.stockMoney = aaa[j].stockMoney;
                    let b = '';
                    for (let k = 0; k < aaa[j].imgArray.length; k++) {
                        b += aaa[j].imgArray[k] + ","
                    }
                    b = b.substring(0, b.length - 1);
                    obj.billName = b;
                    console.log("obj：" + JSON.stringify(obj))
                    joinsSalesCloudStockDetails.push(obj)
                }


                let data = {
                    id: this.editID,
                    mobile: this.editData.mobile,
                    startTime: startTime,
                    endTime: endTime,
                    joinsSalesCloudStockDetails: joinsSalesCloudStockDetails,
                };
                console.log("data：" + JSON.stringify(data))
                updateDraftCheck(data).then((res) => {
                    console.log(res);
                    if (res.code == '200' || res.code == 200) {
                        calculatedBalance(this.id).then((res) => {
                            this.balance = res.data
                            //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                        })

                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name: this.input,
                            mobile: this.input,
                            shopName: this.input,
                            province: this.city,
                            city: this.erae,
                            area: this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);

                            this.total = data.total;
                            for (let i = 0; i < data.rows.length; i++) {
                                data.rows[i].area = data.rows[i].province + data.rows[i].city + data.rows[i].area;
                            }
                            this.tableData = data.rows;
                            //console.log(this.tableData);
                        });
                    } else {
                        this.$message({
                            message: '修改失败!请正确修改信息！',
                            type: 'error'
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name: this.input,
                            mobile: this.input,
                            shopName: this.input,
                            province: this.city,
                            city: this.erae,
                            area: this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);

                            this.total = data.total;
                            for (let i = 0; i < data.rows.length; i++) {
                                data.rows[i].area = data.rows[i].province + data.rows[i].city + data.rows[i].area;
                            }
                            this.tableData = data.rows;
                            //console.log(this.tableData);
                        });
                    }
                });
                done();
            },
            sendDraftCheck() {
                this.edit = false;

                // let date=new Date();
                //
                // let startTime=date.getTime(this.editData.startTime);
                // let endTime=date.getTime(this.editData.endTime);
                let date1 = new Date(this.editData.startTime);
                let startTime = date1.getTime();
                let date2 = new Date(this.editData.endTime);
                let endTime = date2.getTime();

                let joinsSalesCloudStockDetails = [];
                let aaa = this.editDetail;

                for (let j = 0; j < aaa.length; j++) {
                    let obj = {};
                    if (typeof aaa[j].id != "undefined" && aaa[j].id != "") {
                        obj.id = aaa[j].id
                    }
                    obj.documentsCoding = aaa[j].documentsCoding;
                    console.log("stockTime：" + JSON.stringify(aaa[j].stockTime))
                    obj.stockTime = new Date(aaa[j].stockTime).getTime();
                    obj.stockMoney = aaa[j].stockMoney;
                    let b = '';
                    for (let k = 0; k < aaa[j].imgArray.length; k++) {
                        b += aaa[j].imgArray[k] + ","
                    }
                    b = b.substring(0, b.length - 1);
                    obj.billName = b;
                    console.log("obj：" + JSON.stringify(obj))
                    joinsSalesCloudStockDetails.push(obj)
                }


                let data = {
                    id: this.editID,
                    mobile: this.editData.mobile,
                    startTime: startTime,
                    endTime: endTime,
                    joinsSalesCloudStockDetails: joinsSalesCloudStockDetails,
                };
                console.log("data：" + JSON.stringify(data))
                updateDraftCheck(data).then((res) => {
                    console.log(res);
                    if (res.code == '200' || res.code == 200) {
                        calculatedBalance(this.id).then((res) => {
                            this.balance = res.data
                            //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                        })
                        send(data.id).then(response => {
                            this.$message({
                                message: '修改成功！',
                                type: 'success'
                            });

                        })

                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name: this.input,
                            mobile: this.input,
                            shopName: this.input,
                            province: this.city,
                            city: this.erae,
                            area: this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);

                            this.total = data.total;
                            for (let i = 0; i < data.rows.length; i++) {
                                data.rows[i].area = data.rows[i].province + data.rows[i].city + data.rows[i].area;
                            }
                            this.tableData = data.rows;
                            //console.log(this.tableData);
                        });
                    } else {
                        this.$message({
                            message: '修改失败!请正确修改信息！',
                            type: 'error'
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name: this.input,
                            mobile: this.input,
                            shopName: this.input,
                            province: this.city,
                            city: this.erae,
                            area: this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);

                            this.total = data.total;
                            for (let i = 0; i < data.rows.length; i++) {
                                data.rows[i].area = data.rows[i].province + data.rows[i].city + data.rows[i].area;
                            }
                            this.tableData = data.rows;
                            //console.log(this.tableData);
                        });
                    }
                });
                done();
            },
            keepCheck(){
                this.edit = false;

                // let date=new Date();
                //
                // let startTime=date.getTime(this.editData.startTime);
                // let endTime=date.getTime(this.editData.endTime);
                let date1 = new Date(this.editData.startTime);
                let startTime = date1.getTime();
                let date2 = new Date(this.editData.endTime);
                let endTime = date2.getTime();

                let joinsSalesCloudStockDetails = [];
                let aaa = this.editDetail;

                for (let j = 0; j < aaa.length; j++) {
                    let obj = {};
                    if (typeof aaa[j].id != "undefined" && aaa[j].id != "") {
                        obj.id = aaa[j].id
                    }
                    obj.documentsCoding = aaa[j].documentsCoding;
                    console.log("stockTime：" + JSON.stringify(aaa[j].stockTime))
                    obj.stockTime = new Date(aaa[j].stockTime).getTime();
                    obj.stockMoney = aaa[j].stockMoney;
                    let b = '';
                    for (let k = 0; k < aaa[j].imgArray.length; k++) {
                        b += aaa[j].imgArray[k] + ","
                    }
                    b = b.substring(0, b.length - 1);
                    obj.billName = b;
                    console.log("obj：" + JSON.stringify(obj))
                    joinsSalesCloudStockDetails.push(obj)
                }


                let data = {
                    id: this.editID,
                    mobile: this.editData.mobile,
                    startTime: startTime,
                    endTime: endTime,
                    joinsSalesCloudStockDetails: joinsSalesCloudStockDetails,
                };
                console.log("data：" + JSON.stringify(data))
                keepCheck(data).then((res) => {
                    console.log(res);
                    if (res.code == '200' || res.code == 200) {
                        calculatedBalance(this.id).then((res) => {
                            this.balance = res.data
                            //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                        })

                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name: this.input,
                            mobile: this.input,
                            shopName: this.input,
                            province: this.city,
                            city: this.erae,
                            area: this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);

                            this.total = data.total;
                            for (let i = 0; i < data.rows.length; i++) {
                                data.rows[i].area = data.rows[i].province + data.rows[i].city + data.rows[i].area;
                            }
                            this.tableData = data.rows;
                            //console.log(this.tableData);
                        });
                    } else {
                        this.$message({
                            message: '修改失败!请正确修改信息！',
                            type: 'error'
                        });
                        let parmas = {
                            page: this.currentPage,
                            size: this.pageSize,
                            name: this.input,
                            mobile: this.input,
                            shopName: this.input,
                            province: this.city,
                            city: this.erae,
                            area: this.minerae,
                        };
                        findBillList(parmas).then((res) => {
                            let data = JSON.parse(res.data);

                            this.total = data.total;
                            for (let i = 0; i < data.rows.length; i++) {
                                data.rows[i].area = data.rows[i].province + data.rows[i].city + data.rows[i].area;
                            }
                            this.tableData = data.rows;
                            //console.log(this.tableData);
                        });
                    }
                });
                done();
            }

        }

    };
</script>

<style lang="scss">
    .table-container {
        padding: 8px 10px;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
